import React, { Component } from 'react';
import { makeStyles } from 'tss-react/mui';
import { convertStatusToString } from 'utils/utils_legacy';
import { formatReportHours } from 'utils/utils';
import { ColumnWrapper, Column } from 'components/interface/Widget/Widget';
import Skeleton from '@mui/lab/Skeleton';
import Header from 'components/Header/Header';
import Content from 'components/Content/Content';
import Footer from 'components/Footer/Footer';
import { AssignmentStatusChip } from '../../StatusChip';
import { requiresSupplierSignature } from '../../list/utils';
import InformationWidget from './InformationWidget';
import FilesWidget from './FilesWidget';
import PageInfoText from 'components/interface/InfoText/desktop/InfoText';
import Alert, {
    ALERT_STATUS,
} from 'components/interface/alert/Alert';

const useStyles = makeStyles({ name: { AssignmentDesktop } })(
    (theme, _params, _classes) => ({
        alertBox: {
            marginTop: theme.spacing(2),
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        alert: {
            '&:not(:first-of-type)': {
                marginTop: theme.spacing(1),
            },
        },
    })
);

export default function AssignmentDesktop({
    informationProps,
    reportProps,
    filesProps,
    statsProps,
    renderTimesheetButton,
    onSignFile,
    onSignBookingConfirmation,
}) {
    const { classes } = useStyles();

    const renderPage = () => {
        let fileArr = [...filesProps.files];
        if (!!informationProps?.data?.report?.submittedAt) {
            const timesheetFile = {
                id: -1,
                name: 'Tidrapport.pdf',
                isGenerated: true,
                date: informationProps?.data?.report?.submittedAt,
                uploader: {},
                onDownload: informationProps.fetchTimesheetPDF,
            };
            fileArr = [timesheetFile, ...fileArr];
        }

        const renderAlerts = () => {
            let alerts = [];

            if (
                requiresSupplierSignature(
                    informationProps?.data?.bookingConfirmation
                )
            ) {
                alerts.push(
                    <Alert
                        key='signature'
                        className={classes.alert}
                        status={ALERT_STATUS.WARNING}
                        text='Bokningsbekräftelsen behöver signeras med e-legitimation. Du hittar den under Dokument. Klicka på "Signera dokument".'
                        fullWidth
                        withBorder
                    />
                );
            }

            if (alerts.length > 0) {
                return <div className={classes.alertBox}>{alerts}</div>;
            }
            return null;
        };

        return (
            <>
                <PageInfoText
                    title={informationProps?.data?.customer?.name}
                    subtitle={
                        informationProps?.data?.uuid
                            ? `${informationProps?.data?.year}, v.${informationProps?.data?.week}`
                            : null
                    }>
                    {informationProps?.loading ||
                    !informationProps?.data?.status ? (
                        <Skeleton
                            animation='pulse'
                            variant='text'
                            width='96px'
                        />
                    ) : (
                        <AssignmentStatusChip
                            status={informationProps?.data?.status}
                        />
                    )}
                </PageInfoText>
                {renderAlerts()}

                <ColumnWrapper>
                    <Column grow>
                        <InformationWidget
                            {...informationProps}
                            stats={statsProps.stats}
                            totalReportedDays={reportProps.totalReportedDays}
                            totalReportedTime={
                                reportProps.report?.summary
                                    ? formatReportHours(
                                          reportProps.report.summary.totalHours
                                      )
                                    : undefined
                            }
                            renderTimesheetButton={renderTimesheetButton}
                            isStatsLoading={statsProps.loading}
                            isTimereportLoading={reportProps.loading}
                        />
                    </Column>
                    <Column small>
                        <FilesWidget
                            {...filesProps}
                            files={fileArr}
                            bookingConfirmation={
                                informationProps?.data?.bookingConfirmation
                            }
                            onDownloadBookingConfirmation={
                                informationProps.fetchBookingConfirmationPDF
                            }
                            onSignFile={onSignFile}
                            onSignBookingConfirmation={
                                onSignBookingConfirmation
                            }
                        />
                    </Column>
                </ColumnWrapper>
            </>
        );
    };

    return (
        <>
            <Header />
            <Content>{renderPage()}</Content>
            <Footer />
        </>
    );
}
